var React = require('react');

function Tick (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Assets","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("g",{"id":"icon/tick","stroke":"#81c781"},React.createElement("g",{"id":"Group-4-Copy-4","transform":"translate(3.000000, 3.000000)"},[React.createElement("circle",{"id":"Oval-1-Copy-2","cx":"9","cy":"9","r":"9","key":0}),React.createElement("polyline",{"id":"Oval-1-Copy-3","points":"13.2866522 5.9419983 7.19152908 12.3094575 4.55962161 9.80996853","key":1})]))));
}

Tick.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24"};

module.exports = Tick;

Tick.default = Tick;
